module.exports = __webpack_public_path__ + "resources/img/solution_game_gamebase_m.34ce87354be2beee55fda4c91ba68351.png";